// extracted by mini-css-extract-plugin
module.exports = {"paginationLayout":"Section-module_pagination-layout__3ZDFs","numerator":"Section-module_numerator__1QagR"};